



































exports.default =
  components:
    listItem: require('./list_item.vue')

  props: ['options', 'list_item_options']

  data: ->
    tags: []
    selected_tag: {}
    selected_tags: []
    loading: false

  methods:
    loadTags: ->
      filters = @options?.filters || {}
      @tags = []
      @loading = true
      new TagsResource().index(@loadTagsSuccess, null, params: { q: filters })

    loadTagsSuccess: (data) ->
      @loading = false
      @tags = data.tags
      @selected_tags = []

    openDestroyConfirmationModal: (tag) ->
      @selected_tag = tag
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-destroy-tag'

    destroyTag: ->
      Loader.on()
      new TagsResource().destroy(@successDestroyTag, @unknownError, id: @selected_tag.id)

    successDestroyTag: ->
      Loader.off()
      @tags.remove(@selected_tag.id)
      @$store.commit 'removeTag', @selected_tag
      alertify.success('Categoria excluída com sucesso')

    tagUpdated: (tag) ->
      @tags.replaceById(tag)

    tagSelectionToggle: (data) ->
      if data.selected
        if !@selected_tags.find(data.tag.id)
          @selected_tags.push(data.tag)
      else
        @selected_tags.remove(data.tag.id)

      @$emit('selection-changed', @selected_tags)

  created: ->
    @loadTags()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/list.vue